module.exports = __webpack_public_path__ + "static/media/fries.2dbec64f.jpg";